import { BaseService, service } from '../base-service'

export class ResignationConfigService extends BaseService {
  constructor() {
    super('/v2/resignation-config')
  }

  async getResignationConfigByClient(client) {
    const url = `${this.baseURL}/${client}`
    return service.get(url)
  }
}

export const resignationConfigService = new ResignationConfigService()
